/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiIntegrationsDtoAdminPingPaymentSettlementDto
 */
export interface WebApiIntegrationsDtoAdminPingPaymentSettlementDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoAdminPingPaymentSettlementDto
     */
    companyId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoAdminPingPaymentSettlementDto
     */
    companyName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoAdminPingPaymentSettlementDto
     */
    memberUniqueId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoAdminPingPaymentSettlementDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoAdminPingPaymentSettlementDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoAdminPingPaymentSettlementDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoAdminPingPaymentSettlementDto
     */
    recipientType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoAdminPingPaymentSettlementDto
     */
    reference?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoAdminPingPaymentSettlementDto
     */
    paymentOrderId?: string | null;
}

/**
 * Check if a given object implements the WebApiIntegrationsDtoAdminPingPaymentSettlementDto interface.
 */
export function instanceOfWebApiIntegrationsDtoAdminPingPaymentSettlementDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiIntegrationsDtoAdminPingPaymentSettlementDtoFromJSON(json: any): WebApiIntegrationsDtoAdminPingPaymentSettlementDto {
    return WebApiIntegrationsDtoAdminPingPaymentSettlementDtoFromJSONTyped(json, false);
}

export function WebApiIntegrationsDtoAdminPingPaymentSettlementDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiIntegrationsDtoAdminPingPaymentSettlementDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'companyName': !exists(json, 'companyName') ? undefined : json['companyName'],
        'memberUniqueId': !exists(json, 'memberUniqueId') ? undefined : json['memberUniqueId'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'recipientType': !exists(json, 'recipientType') ? undefined : json['recipientType'],
        'reference': !exists(json, 'reference') ? undefined : json['reference'],
        'paymentOrderId': !exists(json, 'paymentOrderId') ? undefined : json['paymentOrderId'],
    };
}

export function WebApiIntegrationsDtoAdminPingPaymentSettlementDtoToJSON(value?: WebApiIntegrationsDtoAdminPingPaymentSettlementDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'companyId': value.companyId,
        'companyName': value.companyName,
        'memberUniqueId': value.memberUniqueId,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'amount': value.amount,
        'recipientType': value.recipientType,
        'reference': value.reference,
        'paymentOrderId': value.paymentOrderId,
    };
}

